import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BRANCHES = [
  "Manesar, Gurugram",
  "Sandila & Bharawan, Uttar Pradesh",
  "Franchise Enquiry",
];

const inputCls =
  "w-full rounded-2xl border border-ink/10 bg-white px-4 py-3 text-sm text-ink placeholder:text-ink/35 focus:outline-none focus:ring-2 focus:ring-peach/60 focus:border-peach transition";

export const InquiryForm = ({ defaultBranch = BRANCHES[0], compact = false, onSuccess }) => {
  const [form, setForm] = useState({
    parent_name: "",
    phone: "",
    email: "",
    branch: defaultBranch,
    child_age: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.parent_name.trim() || !form.phone.trim()) {
      toast.error("Please share your name and phone number.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/inquiries`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error();
      toast.success("Thank you! Our team will call you back shortly.");
      setForm({ ...form, parent_name: "", phone: "", email: "", child_age: "", message: "" });
      onSuccess?.();
    } catch {
      toast.error("Couldn't send right now — please call us at +91 97112 45316.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="inquiry-form">
      <div className={`grid gap-4 ${compact ? "sm:grid-cols-2" : "sm:grid-cols-2"}`}>
        <input
          data-testid="inquiry-input-parent-name"
          className={inputCls}
          placeholder="Parent's name *"
          value={form.parent_name}
          onChange={set("parent_name")}
        />
        <input
          data-testid="inquiry-input-phone"
          className={inputCls}
          placeholder="Phone number *"
          type="tel"
          value={form.phone}
          onChange={set("phone")}
        />
        <input
          data-testid="inquiry-input-email"
          className={inputCls}
          placeholder="Email (optional)"
          type="email"
          value={form.email}
          onChange={set("email")}
        />
        <input
          data-testid="inquiry-input-child-age"
          className={inputCls}
          placeholder="Child's age (optional)"
          value={form.child_age}
          onChange={set("child_age")}
        />
      </div>
      <select
        data-testid="inquiry-select-branch"
        className={inputCls}
        value={form.branch}
        onChange={set("branch")}
      >
        {BRANCHES.map((b) => (
          <option key={b} value={b}>
            {b}
          </option>
        ))}
      </select>
      <textarea
        data-testid="inquiry-input-message"
        className={`${inputCls} min-h-[96px] resize-none`}
        placeholder="Anything you'd like to ask us?"
        value={form.message}
        onChange={set("message")}
      />
      <button
        type="submit"
        data-testid="inquiry-form-submit-button"
        disabled={loading}
        className="w-full inline-flex items-center justify-center gap-2 bg-ink text-cream font-semibold px-6 py-4 rounded-2xl hover:bg-sage transition-colors duration-300 disabled:opacity-60"
      >
        {loading && <Loader2 className="w-4 h-4 animate-spin" />}
        {loading ? "Sending…" : "Request a call back"}
      </button>
    </form>
  );
};
